import React, { FC } from 'react';
import { Progress } from 'antd';
import routePaths from 'config/routes';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import Link from 'src/components/Link';
import { IRootReducers } from 'src/reducers';
import { getProfileCompletedPoints } from 'utils';
import classNames from 'classnames';

interface ICompleteProfilePrompt {
  progress?: number;
  isCompleteProfile?: boolean;
  page?: string;
}

const mapStateToProps = (state: IRootReducers) => {
  return {
    actions: state.app.actions,
  };
};

type Props = ReturnType<typeof mapStateToProps> & ICompleteProfilePrompt;

const CompleteProfilePrompt: FC<Props> = ({
  actions,
  progress,
  isCompleteProfile,
}) => {
  const fullProgress = progress === 100;

  const promptClassnames = classNames('complete-profile__prompt__title', {
    'cta-pointer': !isCompleteProfile,
  });

  return (
    <Link href={routePaths.PAGES.MY_ACCOUNT.COMPLETE_PROFILE}>
      <div className="complete-profile__prompt">
        {!fullProgress && (
          <div className={promptClassnames}>
            <span className="">
              <FormattedMessage
                id={'page.account.my-account-complete-block-cta'}
                values={{ points: getProfileCompletedPoints(actions) }}
              />
            </span>
          </div>
        )}
        {fullProgress && (
          <div className="cta-profile__completed">
            <FormattedMessage
              id="menu.header.complete-profile"
              values={{ points: getProfileCompletedPoints(actions) }}
            />
          </div>
        )}
        {!!progress && (
          <Progress
            className="complete-profile__prompt__progress"
            percent={progress}
            showInfo={false}
            strokeWidth={12}
            strokeColor="#218500"
          />
        )}
      </div>
    </Link>
  );
};

export default connect(mapStateToProps)(CompleteProfilePrompt);
